import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a673d0c")

_pushScopeId("data-v-1a673d0c")
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_4 = {
  key: 1,
  id: "pickerField",
  class: "p-col-9"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = {
  key: 2,
  class: "p-col-9"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  id: "taxon-picker",
  class: "p-col-12 required"
}
const _hoisted_14 = { class: "section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _component_number_picker = _resolveComponent("number-picker")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_boolean_picker = _resolveComponent("boolean-picker")!
  const _component_image_picker = _resolveComponent("image-picker")!
  const _component_person_picker = _resolveComponent("person-picker")!
  const _component_specimen_picker = _resolveComponent("specimen-picker")!
  const _component_taxon_picker = _resolveComponent("taxon-picker")!
  const _component_Panel = _resolveComponent("Panel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, {
      toggleable: true,
      collapsed: _ctx.isCollapsed,
      class: "p-col-8 p-offset-2 required"
    }, {
      header: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('form.species_record') + ' ') + " " + _toDisplayString(_ctx.recordIdx + 1) + " : " + _toDisplayString(_ctx.taxonNameDict[_ctx.recordIdx]), 1)
      ]),
      icons: _withId(() => [
        _withDirectives(_createVNode(_component_Button, {
          class: "p-mr-1 p-button-rounded p-button-danger tooltipButton",
          icon: "pi pi-trash",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.remove($event)), ["prevent"]))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('form.removeSingleRecord'),
            void 0,
            { right: true }
          ]
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_ConfirmPopup),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.record, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "p-field p-grid",
              key: item
            }, [
              (item.type !== 'hidden')
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _withDirectives(_createVNode(_component_Button, {
                      class: ["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }],
                      tabindex: "-1"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_info_button),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]), [
                      [
                        _directive_tooltip,
                        _ctx.$t(item.help),
                        void 0,
                        { right: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.type !== 'group' && item.type !== 'hidden')
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    (item.component === _ctx.ComponentEnum.StringPicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_5, [
                          _createVNode(_component_string_picker, {
                            class: "field",
                            onSelect: _ctx.select,
                            value: item.value,
                            name: item.name,
                            placeholder: _ctx.$t(item.placeholder)
                          }, null, 8, ["onSelect", "value", "name", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.NumberPicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_6, [
                          _createVNode(_component_number_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            placeholder: _ctx.$t(item.placeholder),
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "placeholder", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.CategoryPicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_7, [
                          _createVNode(_component_category_picker, {
                            class: "field",
                            name: item.name,
                            api: item.api,
                            filter: item.filter,
                            clearable: item.clearable,
                            value: item.value == null ? item.defaultValue : item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.BooleanPicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, [
                          _createVNode(_component_boolean_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.ImagePicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_9, [
                          _createVNode(_component_image_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.PersonPicker)
                      ? (_openBlock(), _createBlock("span", _hoisted_10, [
                          _createVNode(_component_person_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select,
                            api: item.api
                          }, null, 8, ["name", "value", "onSelect", "api"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (item.type === 'group' && item.type !== 'hidden')
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      (item.component === _ctx.ComponentEnum.SpecimenPicker)
                        ? (_openBlock(), _createBlock("span", _hoisted_12, [
                            _createVNode(_component_specimen_picker, {
                              class: "field",
                              name: item.name,
                              value: item.value,
                              title: item.title,
                              onSelect: _ctx.select
                            }, null, 8, ["name", "value", "title", "onSelect"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.component === _ctx.ComponentEnum.TaxonPicker)
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode("span", _hoisted_14, [
                              _createVNode(_component_taxon_picker, {
                                onSelect: _ctx.select,
                                name: item.name,
                                value: item.value,
                                title: item.title,
                                required: item.required
                              }, null, 8, ["onSelect", "name", "value", "title", "required"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
})